import {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {fetchDepartment} from 'web/redux/actions/DepartmentActions';
import enumList from 'web/utils/enumList';

export const useDepartmentModelControl = (setNeedSearchLoad) => {
  const dispatch = useDispatch();
  const departmentModelRef = useRef(null);
  const [needDepartmentModelLoad, setNeedDepartmentModelLoad] = useState(false);
  const [departmentModelMode, setDepartmentModelMode] = useState();
  useEffect(() => {
    if (departmentModelRef.current) {
      departmentModelRef.current = new bootstrap.Modal(
        departmentModelRef.current,
      );
    }
  }, [departmentModelRef]);

  const toggleDepartmentModel = (isShow, mode, departmentCode) => {
    if (departmentModelRef) {
      if (isShow) {
        setNeedDepartmentModelLoad(true);
        if (mode === enumList.modalMode.edit) {
          dispatch(fetchDepartment(departmentCode));
        }
        console.log(mode);

        setDepartmentModelMode(mode);
        departmentModelRef.current.show();
      } else {
        setNeedDepartmentModelLoad(false);
        departmentModelRef.current.hide();
      }
    }
  };

  return {
    departmentModelRef,
    toggleDepartmentModel,
    departmentModelMode,
    needDepartmentModelLoad,
    setNeedDepartmentModelLoad,
  };
};
